var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 17.7757V0H27.7745V17.7757H0ZM26.6638 1.11084H1.11133V16.6645H26.6638V1.11084ZM11.4566 5.3291C11.3958 5.3291 11.3372 5.3508 11.283 5.38118C11.1723 5.44411 11.1094 5.56779 11.1094 5.69364V12.7588C11.1094 12.8846 11.1745 13.0083 11.283 13.0712C11.3372 13.1038 11.3958 13.106 11.4566 13.106C11.5173 13.106 11.5933 13.1038 11.6475 13.0712L17.7579 9.52999C17.8664 9.46706 17.9315 9.34338 17.9315 9.21753C17.9315 9.09167 17.8664 8.98535 17.7579 8.92242L11.6475 5.38118C11.5933 5.3508 11.5173 5.3291 11.4566 5.3291ZM5.50238 19.4943C5.47417 19.1884 5.69984 18.915 6.00579 18.8868H6.05787H6.10995H21.6637C21.8633 18.8846 22.0499 18.9887 22.1519 19.1623C22.2517 19.3359 22.2517 19.5486 22.1519 19.7222C22.0499 19.8957 21.8633 19.9999 21.6637 19.9977H6.10995C5.80399 20.0259 5.53059 19.8003 5.50238 19.4943Z",
    fill: "#62AA51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVid);
export default __webpack_public_path__ + "static/media/vid.9f069f961e07f81c125e70b432c27281.svg";
export { ForwardRef as ReactComponent };